import axios from "axios";
import { toast } from "react-toastify";
import { CLEAR_FORM, SET_FORM, SUBMIT_FORM } from "../constant/Type";
import { BASE_URL } from "../constant/URL";

export const submitFormFDM3D = (values, data, file) => async (dispatch) => {
  let formData = new FormData();

  if (data.email) {
    formData.append("email", data.email);
  }
  if (data.project) {
    formData.append("project", data.project);
  }
  if (data.name) {
    formData.append("name", data.name);
  }
  if (data.company) {
    formData.append("company", data.company);
  }

  if (data.contactNumber) {
    formData.append("contactNumber", data.contactNumber);
  }
  if (data.deliveryAddress) {
    formData.append("deliveryAddress", data.deliveryAddress);
  }
  if (data.deliveryDate) {
    formData.append("deliveryDate", data.deliveryDate);
  }
  if (data.serviceNeeded) {
    formData.append("serviceNeeded", data.serviceNeeded);
  }

  if (values.material) {
    formData.append("material", values.material);
  }
  if (values.color) {
    formData.append("color", values.color);
  }
  if (values.finishing) {
    formData.append("finishing", values.finishing);
  }
  if (values.strength) {
    formData.append("strength", values.strength);
  }
  if (values.details) {
    formData.append("details", values.details);
  }
  if (values.quantity) {
    formData.append("quantity", values.quantity);
  }
  if (file) {
    for (let i = 0; i < file.length; i++) {
      formData.append("file", file[i]);
    }
  }

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  };
  try {
    await axios.post(`${BASE_URL}/api/v1/order`, formData, config);
    dispatch({
      type: SUBMIT_FORM,
    });
    toast.success("Form Submitetd!");
    return true;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.message);
    return false;
  }
};

export const submitFormSLA3D = (values, data, file) => async (dispatch) => {
  let formData = new FormData();

  if (data.email) {
    formData.append("email", data.email);
  }
  if (data.project) {
    formData.append("project", data.project);
  }
  if (data.name) {
    formData.append("name", data.name);
  }
  if (data.company) {
    formData.append("company", data.company);
  }

  if (data.contactNumber) {
    formData.append("contactNumber", data.contactNumber);
  }
  if (data.deliveryAddress) {
    formData.append("deliveryAddress", data.deliveryAddress);
  }
  if (data.deliveryDate) {
    formData.append("deliveryDate", data.deliveryDate);
  }
  if (data.serviceNeeded) {
    formData.append("serviceNeeded", data.serviceNeeded);
  }
  // new fields
  if (values.designNeeded) {
    formData.append("designNeeded", values.designNeeded);
  }
  if (values.color) {
    formData.append("color", values.color);
  }

  if (values.details) {
    formData.append("details", values.details);
  }
  if (values.quantity) {
    formData.append("quantity", values.quantity);
  }
  if (file) {
    for (let i = 0; i < file.length; i++) {
      formData.append("file", file[i]);
    }
  }

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  };
  try {
    await axios.post(`${BASE_URL}/api/v1/order`, formData, config);
    dispatch({
      type: SUBMIT_FORM,
    });
    toast.success("Form Submitetd!");
    return true;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.message);
    return false;
  }
};

export const submitFormLaserCutting =
  (values, data, file) => async (dispatch) => {
    let formData = new FormData();

    if (data.email) {
      formData.append("email", data.email);
    }
    if (data.project) {
      formData.append("project", data.project);
    }
    if (data.name) {
      formData.append("name", data.name);
    }
    if (data.company) {
      formData.append("company", data.company);
    }

    if (data.contactNumber) {
      formData.append("contactNumber", data.contactNumber);
    }
    if (data.deliveryAddress) {
      formData.append("deliveryAddress", data.deliveryAddress);
    }
    if (data.deliveryDate) {
      formData.append("deliveryDate", data.deliveryDate);
    }
    if (data.serviceNeeded) {
      formData.append("serviceNeeded", data.serviceNeeded);
    }

    if (values.material) {
      formData.append("material", values.material);
    }
    if (values.materialNeeded) {
      formData.append("materialNeeded", values.materialNeeded);
    }
    if (values.color) {
      formData.append("color", values.color);
    }
    if (values.thickness) {
      formData.append("thickness", values.thickness);
    }

    if (values.details) {
      formData.append("details", values.details);
    }
    if (values.quantity) {
      formData.append("quantity", values.quantity);
    }
    if (file) {
      for (let i = 0; i < file.length; i++) {
        formData.append("file", file[i]);
      }
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    };
    try {
      await axios.post(`${BASE_URL}/api/v1/order`, formData, config);
      dispatch({
        type: SUBMIT_FORM,
      });
      toast.success("Form Submitetd!");
      return true;
    } catch (err) {
      console.log(err);
      toast.error(err.response.data.message);
      return false;
    }
  };

export const submitFormPCB = (values, data, file) => async (dispatch) => {
  let formData = new FormData();

  if (data.email) {
    formData.append("email", data.email);
  }
  if (data.project) {
    formData.append("project", data.project);
  }
  if (data.name) {
    formData.append("name", data.name);
  }
  if (data.company) {
    formData.append("company", data.company);
  }

  if (data.contactNumber) {
    formData.append("contactNumber", data.contactNumber);
  }
  if (data.deliveryAddress) {
    formData.append("deliveryAddress", data.deliveryAddress);
  }
  if (data.deliveryDate) {
    formData.append("deliveryDate", data.deliveryDate);
  }
  if (data.serviceNeeded) {
    formData.append("serviceNeeded", data.serviceNeeded);
  }
  // EXTRA
  if (values.designNeeded) {
    formData.append("designNeeded", values.designNeeded);
  }
  if (values.layers) {
    formData.append("layers", values.layers);
  }
  if (values.finishing) {
    formData.append("finishing", values.finishing.join(", "));
  }
  if (values.details) {
    formData.append("details", values.details);
  }
  if (file) {
    for (let i = 0; i < file.length; i++) {
      formData.append("file", file[i]);
    }
  }
  if (values.quantity) {
    formData.append("quantity", values.quantity);
  }

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  };
  try {
    await axios.post(`${BASE_URL}/api/v1/order`, formData, config);
    dispatch({
      type: SUBMIT_FORM,
    });
    toast.success("Form Submitetd!");
    return true;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.message);
    return false;
  }
};

export const submitFormProductDevelopment =
  (values, data, file) => async (dispatch) => {
    let formData = new FormData();

    if (data.email) {
      formData.append("email", data.email);
    }
    if (data.project) {
      formData.append("project", data.project);
    }
    if (data.name) {
      formData.append("name", data.name);
    }
    if (data.company) {
      formData.append("company", data.company);
    }

    if (data.contactNumber) {
      formData.append("contactNumber", data.contactNumber);
    }
    if (data.deliveryAddress) {
      formData.append("deliveryAddress", data.deliveryAddress);
    }
    if (data.deliveryDate) {
      formData.append("deliveryDate", data.deliveryDate);
    }
    if (data.serviceNeeded) {
      formData.append("serviceNeeded", data.serviceNeeded);
    }
    // EXTRA
    if (values.includes) {
      formData.append("includes", values.includes.join(", "));
    }
    if (values.quality) {
      formData.append("quality", values.quality);
    }
    if (values.features) {
      formData.append("features", values.features);
    }

    if (file) {
      for (let i = 0; i < file.length; i++) {
        formData.append("file", file[i]);
      }
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    };
    try {
      await axios.post(`${BASE_URL}/api/v1/order`, formData, config);
      dispatch({
        type: SUBMIT_FORM,
      });
      toast.success("Form Submitetd!");
      return true;
    } catch (err) {
      console.log(err);
      toast.error(err.response.data.message);
      return false;
    }
  };

export const setForm = (values) => (dispatch) => {
  dispatch({
    type: SET_FORM,
    payload: values,
  });
};

export const clearForm = () => (dispatch) => {
  dispatch({
    type: CLEAR_FORM,
  });
};
